import { ceil } from 'lodash'

tag pagination-tag
	prop total
	prop limit
	prop onPage
	prop currentPage

	get pages
		ceil(total / limit)

	get visiblePages
		const totalPages = pages
		if totalPages < 1
			return []
		if totalPages <= 8
			return [1 .. totalPages]

		const firstPages = [1, 2]
		const lastPages = [ totalPages - 1, totalPages]
		return { first: firstPages, last: lastPages }

	<self.pagination-tag>
		# First page button
		<a.btn.btn-page.btn-nav @click=onPage(1) .disabled=(currentPage == 1)>
			<i.fa.fa-fw.fa-angle-double-left>

		# Previous page button
		<a.btn.btn-page.btn-nav @click=onPage(currentPage - 1) .disabled=(currentPage == 1)>
			<i.fa.fa-fw.fa-angle-left>

		if pages <= 6
			# Show all pages if 8 or fewer
			for page in visiblePages
				<a.btn.btn-page @click=onPage(page) .active=(currentPage == page)> page
		else
			# Show first 3 pages
			for page in visiblePages.first
				<a.btn.btn-page @click=onPage(page) .active=(currentPage == page)> page

			# Show ellipsis or current page if selected in middle
			if currentPage > 2 && currentPage < (pages - 1)
				<a.btn.btn-page.active @click=onPage(currentPage)> currentPage
			else
				<span.btn.btn-page.ellipsis> "..."

			# Show last 3 pages
			for page in visiblePages.last
				<a.btn.btn-page @click=onPage(page) .active=(currentPage == page)> page

		# Next page button
		<a.btn.btn-page.btn-nav @click=onPage(currentPage + 1) .disabled=(currentPage == pages)>
			<i.fa.fa-fw.fa-angle-right>

		# Last page button
		<a.btn.btn-page.btn-nav @click=onPage(pages) .disabled=(currentPage == pages)>
			<i.fa.fa-fw.fa-angle-double-right>

css .pagination-tag
	d:flex
	jc:center
	ai:center
	mx:auto
	gap:0

	.btn-page
		fs:1.25em
		c:cooler9 @hover:cooler1
		bgc:cooler1 @hover:cooler9
		cursor:pointer
		bw:1px 0 1 1
		bs:solid
		bc:cooler3
		bwr@last:1px
		rdr@last:.5em
		rdl@first:.5em
		p:0.5em 0.75em
		d:flex
		ai:center
		jc:center
		w:50px
		h:50px

		&.btn-nav
			w:25px
			h:50px

		&.active
			c:cooler1
			bgc:cooler9

		&.disabled
			c:cooler5
			bgc:cooler2
			cursor:not-allowed
			opacity:0.6

			&:hover
				c:cooler5
				bgc:cooler2

	.ellipsis
		cursor:default

		&:hover
			c:cooler7
			bgc:cooler1